import { cx } from '@libs/classnames';
import { Loader } from '@ui/components/Loader';

import { RoomStatus } from '@features/video/types';

import styles from './StreamStatus.module.css';

export const ROOM_STATUS_LABELS: Record<RoomStatus, string> = {
  connecting: 'Подключение...',
  reconnecting: 'Переподключение...',
  waiting: 'Судья проверяет трансляцию',
  live: 'В эфире',
};

export type Props = {
  className?: string;
  status: RoomStatus;
};

export function StreamStatus({ className, status }: Props) {
  return (
    <div className={cx(styles.status, styles[`is_${status}`], className)}>
      {status === 'live' ? (
        <i className={styles.status__dot} />
      ) : (
        <Loader className={styles.status__loader} preset="mobile" ignoreClubColors />
      )}
      {ROOM_STATUS_LABELS[status]}
    </div>
  );
}
